"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/badge/style/index.js
// module id = 290
// module chunks = 1